export default {
	appointment_save_failed_notification: 'Der Termin konnte nicht gespeichert werden',
	appointment_saved_notification: 'Der Termin wurde gespeichert',
	calendar_agenda_button_today_label: 'Heute',
	calendar_agenda_next_day_aria_label: 'Nächster Tag',
	calendar_agenda_previous_day_aria_label: 'Vorheriger Tag',
	calendar_agenda_time_independent_appointments_timeline_entry_label: 'zeitunabhängige Termine',
	calendar_agenda_week_view_aria_label: 'Zur Wochenansicht',
	calendar_appointment_access_label: 'Zugriff',
	calendar_appointment_access_label_private: 'Privat',
	calendar_appointment_access_label_public: 'Öffentlich',
	calendar_appointment_alarm_before_days_label: 'Tag(e)',
	calendar_appointment_alarm_before_deactivated_label: 'kein Alarm',
	calendar_appointment_alarm_before_hours_label: 'Stunde(n)',
	calendar_appointment_alarm_before_minutes_label: 'Minute(n)',
	calendar_appointment_alarm_before_select_option_days_label: 'Tag(e)',
	calendar_appointment_alarm_before_select_option_deactivated_label: 'kein Alarm',
	calendar_appointment_alarm_before_select_option_hours_label: 'Stunde(n)',
	calendar_appointment_alarm_before_select_option_minutes_label: 'Minute(n)',
	calendar_appointment_alarm_label: 'Alarm vor Termin',
	calendar_appointment_day: 'Tag',
	calendar_appointment_delete_dialog_confirm_cancel_label: 'Nein',
	calendar_appointment_delete_dialog_confirm_message: 'Möchten Sie diesen Termin wirklich löschen?',
	calendar_appointment_delete_dialog_confirm_ok_label: 'Ja',
	calendar_appointment_delete_dialog_confirm_title: 'Termin löschen',
	calendar_appointment_description_label: 'Beschreibung',
	calendar_appointment_duration_hours: 'Stunden',
	calendar_appointment_duration_hours_short: 'Std.',
	calendar_appointment_duration_label: 'Dauer',
	calendar_appointment_duration_minutes: 'Minuten',
	calendar_appointment_duration_minutes_short: 'Min.',
	calendar_appointment_edit_repetition_notification:
		'Info - Sie bearbeiten einen Wiederholungstermin.\n\nEs wird nur der aktuelle Termin bearbeitet und nicht alle Termine der Wiederholung.',
	calendar_appointment_edit_repetition_ok_button_label: 'Ok, verstanden',
	calendar_appointment_list: 'Liste',
	calendar_appointment_location_label: 'Ort',
	calendar_appointment_month: 'Monat',
	calendar_appointment_participant_accept_label: 'Bestätigung',
	calendar_appointment_participant_active_label: 'Aktiver Teilnehmer',
	calendar_appointment_participant_active_name: 'Name',
	calendar_appointment_participant_alert_label: 'Alarm',
	calendar_appointment_participant_remove_aria_label: 'Teilnehmer entfernen',
	calendar_appointment_participant_write_label: 'Schreibrecht',
	calendar_appointment_participants_label: 'Teilnehmer',
	calendar_appointment_repetition_delete_scope_all: 'inkl. aller folgenden Wiederholungstermine',
	calendar_appointment_repetition_delete_scope_message: 'Welche Termine sollen gelöscht werden?',
	calendar_appointment_repetition_delete_scope_single: 'Nur diesen Termin',
	calendar_appointment_repetition_delete_scope_title: 'Termin löschen',
	calendar_appointment_repetition_ending_amount: 'Nach Anzahl',
	calendar_appointment_repetition_ending_amount_label: 'Anzahl',
	calendar_appointment_repetition_ending_date: 'Am Datum',
	calendar_appointment_repetition_ending_date_label: 'Enddatum',
	calendar_appointment_repetition_ending_label: 'Ende',
	calendar_appointment_repetition_ending_never: 'Nie (bis 2038)',
	calendar_appointment_repetition_interval_label: 'Intervall',
	calendar_appointment_repetition_label: 'Wiederholung',
	calendar_appointment_repetition_month_by_date: 'Am gleichen Datum',
	calendar_appointment_repetition_month_by_day: 'Am gleichen Wochentag',
	calendar_appointment_repetition_off: 'inaktiv',
	calendar_appointment_repetition_on: 'aktiv',
	calendar_appointment_repetition_save_scope_all: 'inkl. aller folgenden Wiederholungstermine',
	calendar_appointment_repetition_save_scope_message: 'Wie soll der Termin gespeichert werden?',
	calendar_appointment_repetition_save_scope_single: 'Nur diesen Termin',
	calendar_appointment_repetition_save_scope_title: 'Termin speichern',
	calendar_appointment_repetition_type_day: 'Täglich',
	calendar_appointment_repetition_type_label: 'Wiederholungstyp',
	calendar_appointment_repetition_type_month: 'Monatlich',
	calendar_appointment_repetition_type_week: 'Wöchentlich',
	calendar_appointment_repetition_type_year: 'Jährlich',
	calendar_appointment_repetition_weekday_fri: 'Fr',
	calendar_appointment_repetition_weekday_mon: 'Mo',
	calendar_appointment_repetition_weekday_sat: 'Sa',
	calendar_appointment_repetition_weekday_sun: 'So',
	calendar_appointment_repetition_weekday_thu: 'Do',
	calendar_appointment_repetition_weekday_tue: 'Di',
	calendar_appointment_repetition_weekday_wed: 'Mi',
	calendar_appointment_start_label: 'Beginn',
	calendar_appointment_start_minutes: 'Minuten',
	calendar_appointment_start_oclock: 'Uhr',
	calendar_appointment_time_type_allday: 'ganztags',
	calendar_appointment_time_type_fixed: 'feste Zeit',
	calendar_appointment_time_type_label: 'Modus',
	calendar_appointment_time_type_time_independent: 'zeitunabhängig',
	calendar_appointment_type_label: 'Termintyp',
	calendar_appointment_user_selection: 'Benutzerauswahl',
	calendar_appointment_week: 'Woche',
	calendar_appointment_year: 'Jahr',
	calendar_appointment_years: 'Jahre',
	calendar_datefield_close: 'Schließen',
};
